import { useContext } from 'react';
import { RouteContext, RouteContextValue } from '../contexts/RouteContext';

export function useRoute(): RouteContextValue {
  const context = useContext(RouteContext);
  if (context === undefined) {
    throw new Error('useRoute must be used within a RouteProvider');
  }
  return context;
}
